<template>
    <div class="fill-layer" v-if="isShow">
        <div class="fill-content">
            <h3>填写收货信息</h3>
            <ul class="form-list">
                <li><slot name="userName"></slot><slot name="userTel"></slot></li>
                
                <li>
                    <div class="input-wrap" @click="showSelect"><slot name="userDistrict"></slot><i class="icon icon-down-tb"></i></div>
                    <Distpicker :isShow="isShowSelect" @on-select="selectDist" @on-close="closeSelect"></Distpicker>
                </li>
                <li><slot name="userAddress"></slot></li>

                <li><slot name="userEmail"></slot></li>
            </ul>
            <a class="btn-item btn-submit" href="javascript: void(0)" @click="submitInfo">确认提交</a>
            <p class="tip">*以上信息确认后，不可修改</p>
            <a class="icon icon-close" href="javascript: void(0)" @click="closeLayer"></a>
        </div>
    </div>
</template>

<script>
    import Distpicker from '../distpicker'
    export default {
        name: 'FillInfo',
        components: {
            Distpicker
        },
        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isShowSelect: false
            }
        },
        methods: {
            closeLayer () {
                this.$emit('on-close', false)
            },
            showSelect () {
                this.isShowSelect = !this.isShowSelect
            },
            closeSelect () {
                this.isShowSelect = false
            },
            selectDist (data) {
                this.$emit('on-select', data)
            },
            submitInfo () {
                this.$emit('on-submit')
            }
        }
    }
</script>

<style lang="less" scoped>
    .fill-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        .fill-content{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 501px;
            height: 406px;
            padding: 26px 30px 0;
            margin-top: -172px;
            margin-left: -251px;
            background-color: #fff;
            border: #d3dadd solid 1px;
            border-radius: 4px;
            h3{
                font-size: 22px;
                line-height: 36px;
            }
            .form-list{
                padding-top: 13px;
                li{
                    position: relative;
                    height: 46px;
                    margin-bottom: 15px;
                    .form-item{
                        width: 100%;
                        height: 46px;
                        padding: 0 15px;
                        border: #d3dadd solid 1px;
                        font-size: 16px;
                        &::placeholder{
                            color: #919b9f;
                        }
                        &.item-name{
                            width: 150px;
                            margin-right: 15px;
                        }
                        &.item-tel{
                            width: 273px;
                        }
                        &.item-district{}
                        &.item-address{}
                    }
                    .icon-down-tb{
                        position: absolute;
                        right: 10px;
                        top: 12px;
                        width: 21px;
                        height: 21px;
                        background: url("../../assets/images/down_area.png") no-repeat center center;
                        background-size: 100%;
                        cursor: pointer;
                    }
                }
            }
            .tip{
                font-size: 12px;
                color: #fe2e22;
                line-height: 24px;
            }
            .btn-submit{
                display: block;
                width: 100%;
                height: 46px;
                background-color: #fbc500;
                font-size: 16px;
                line-height: 46px;
                text-align: center;
            }
            .icon-close {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 29px;
                height: 29px;
                background: url("../../assets/images/close.png") no-repeat center center #d3dadd;
                background-size: 16px 16px;
                border-radius: 50%;
            }
        }
    }
</style>
